import { render, staticRenderFns } from "./limit.vue?vue&type=template&id=3192c88a&scoped=true&"
import script from "./limit.js?vue&type=script&lang=js&"
export * from "./limit.js?vue&type=script&lang=js&"
import style0 from "./limit.vue?vue&type=style&index=0&id=3192c88a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192c88a",
  null
  
)

export default component.exports